
import { registerPlugin, PluginListenerHandle, Capacitor } from '@capacitor/core';

export interface ManagedConfigurationsPlugin {
    getUnitCode(): Promise<{ value: string }>;
    addListener(eventName: 'restrictionsChanged', listenerFunc: (data: { value: string }) => void): Promise<PluginListenerHandle>;
}

const ManagedConfigurations = registerPlugin<ManagedConfigurationsPlugin>('ManagedConfigurations', {
    web: {
        getUnitCode: async () => ({ value: 'WEB-DEV-MODE' }),
        addListener: async () => ({ remove: () => { } } as any)
    }
});

export default ManagedConfigurations;
